// extracted by mini-css-extract-plugin
export var colorSquare = "_jm-0";
export var danger = "_jm-5";
export var lightPink = "_jm-8";
export var neutralBlue = "_jm-7";
export var neutralYellow = "_jm-6";
export var normal = "_jm-1";
export var primary = "_jm-2";
export var primaryLight = "_jm-3";
export var solidBlack = "_jm-g";
export var solidGreen = "_jm-b";
export var solidLightBlue = "_jm-d";
export var solidNavy = "_jm-c";
export var solidOrange = "_jm-f";
export var solidPink = "_jm-e";
export var solidRed = "_jm-9";
export var solidYellow = "_jm-a";
export var success = "_jm-4";